import {useIntl} from 'react-intl'
import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {ROUTES} from '../../../../../_gori/constants'
import {useAuth} from '../../../auth'

type ManifestStatus = 'paid' | 'pending' | 'expired' | 'fraud' | 'invalid'

interface StatusAlertProps {
  status: ManifestStatus
  statusConfig: {color: string; titleKey: string}
}

export function StatusAlert({status, statusConfig}: StatusAlertProps) {
  const intl = useIntl()
  const {currentUser} = useAuth()

  return (
    <div className='gori-signature-status-section'>
      <div
        className={clsx(`alert alert-${statusConfig.color} gori-signature-status-alert`, {
          'padding-invalid': status === 'invalid',
        })}
        role='alert'
      >
        <h4 className='alert-heading mb-2'>
          {intl.formatMessage({id: `GORI_SIGNATURE_MANIFEST_TYPE`})}:{' '}
          {intl.formatMessage({id: statusConfig.titleKey})}
        </h4>
        <p className='mb-0'>
          {intl.formatMessage({
            id: `GORI_SIGNATURE_MESSAGE_${status === 'invalid' ? 'FRAUD' : status.toUpperCase()}`,
          })}
        </p>
      </div>

      {status === 'pending' && (
        <p className='gori-signature-manifest-text'>
          {intl.formatMessage({id: 'GORI_SIGNATURE_MANIFEST_INSTRUCTION'})}{' '}
          <Link
            to={currentUser ? ROUTES.END_OF_DAY.OPEN_SHIPMENTS : ROUTES.AUTH.LOGIN}
            className='gori-signature-manifest-link'
          >
            {intl.formatMessage({id: 'GORI_SIGNATURE_MANIFEST_LINK'})}
          </Link>
        </p>
      )}

      {(status === 'expired' || status === 'fraud' || status === 'invalid') && (
        <p className='gori-signature-manifest-text'>
          {intl.formatMessage(
            {id: 'GORI_SIGNATURE_FRAUD_INSTRUCTION'},
            {
              uspsLink: (
                <a
                  href='https://www.uspis.gov/report'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='gori-signature-manifest-link'
                >
                  {intl.formatMessage({id: 'GORI_SIGNATURE_FRAUD_LINK'})}
                </a>
              ),
            }
          )}
        </p>
      )}
    </div>
  )
}
StatusAlert.displayName = 'StatusAlert'
